import { render, staticRenderFns } from "./ListagemCotacaoFreteHeader.vue?vue&type=template&id=19f31600"
import script from "./ListagemCotacaoFreteHeader.vue?vue&type=script&lang=js"
export * from "./ListagemCotacaoFreteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports